/**
 * @desc 一键入库
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.InMasterOncePutStorageDto, options?: any) {
  return updateResponse(
    http(URL + `/inMaster/oncePutStorage`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
